import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { CircleSparkIcon } from '@synoptic/ui-kit/icons/react/circle-spark.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { OpenAiKey } from '@/__generated__/schema-types';
import { useSwitchOpenAIKey } from '@/components/ai-secret-key/use-set-open-ai-key';
import {
  goToSettingsButton,
  tryAIFilters,
  tryAIFiltersContent,
  tryAIFiltersDescription,
  tryAIFiltersHeader,
} from './ai-filters.css';

export const DisabledAIFilters = ({
  openAIKey,
}: {
  openAIKey: Pick<OpenAiKey, 'key'>;
}) => {
  const { switchOpenAIKey, loading } = useSwitchOpenAIKey();
  return (
    <div className={tryAIFilters}>
      <div>
        <CircleSparkIcon
          color={themeVars.container.foreground.brand}
          width={16}
          height={16}
        />
      </div>
      <div className={tryAIFiltersContent}>
        <h2 className={tryAIFiltersHeader}>Use AI Filters</h2>
        <p className={tryAIFiltersDescription}>
          API key paused. You can re-enable it from here.
        </p>
        <Button
          onClick={() => switchOpenAIKey({ ...openAIKey, enabled: true })}
          variant="secondary"
          loading={loading}
          size="small"
          className={goToSettingsButton}
        >
          Enable key
        </Button>
      </div>
    </div>
  );
};
